import { Box, Theme, Typography, useTheme } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { creditOfferLandingPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";

import { useCreditOffer } from "../../hooks/useCreditOffer";
import { CoinIcon } from "../subscriptions/CoinIcon";
import { SubscriptionEsaDisableTooltip } from "./SubscriptionEsaDisableTooltip";

export function CreditOfferNavItem() {
  const { isEsaSession } = useSession();
  const theme = useTheme();
  const { t } = useTranslation("client\\components\\nav\\CreditOfferNavItem");
  const navigate = useNavigation();
  const { creditOffer, loading } = useCreditOffer();
  const planCredits = creditOffer?.eligiblePlans?.[0] || 0;
  const bonusCredits = creditOffer?.amountCredits || 0;
  const creditsToShow = bonusCredits + planCredits;

  if (loading || !creditOffer) {
    return null;
  }

  const handleClick = () => {
    navigate(creditOfferLandingPath());
  };

  return (
    <SubscriptionEsaDisableTooltip
      component="SubscriptionCreditNavItem"
      tooltip={t(
        "Membership credits aren’t available in a ClassWallet session. To use your credits",
      )}
      placement="top"
    >
      <TrackedButton
        variant="link"
        trackingName="subscription_credit_nav_item"
        data-test-id="subscription-credit-nav-item"
        sx={(theme: Theme) => ({
          border: "none",
          paddingX: 8,
          paddingTop: 4,
          display: "block",
          color: "black",
          [theme.breakpoints.down("sm")]: {
            display: "flex",
            margin: "auto",
            paddingTop: 0,
          },
        })}
        disabled={isEsaSession}
        onClick={handleClick}
      >
        <Box flex={true}>
          <Box sx={{ paddingTop: "0.2rem", paddingRight: "0.5rem" }}>
            <CoinIcon
              fillColor={theme.palette.common.white}
              strokeColor={theme.palette.grey[500]}
            />
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
            }}
          >
            {`${creditsToShow}`}
          </Typography>
        </Box>
        <Box
          sx={(theme: Theme) => ({
            display: "flex",
            flexDirection: "row-reverse",
            [theme.breakpoints.down("sm")]: {
              paddingLeft: "0.5rem",
            },
          })}
        >
          <Typography variant="body2">{t("Credits")}</Typography>
        </Box>
      </TrackedButton>
    </SubscriptionEsaDisableTooltip>
  );
}
